<template>
  <div class="loader text-center">
    <small>{{ I18n.t("loading") }}</small>
  </div>
</template>

<script>
  export default {
    name: 'Loader',
  };
</script>



// WEBPACK FOOTER //
// app/javascript/packs/shared/components/loader.vue?e7c96cb2